<template>
    <div class="px-3 pt-3" role="tabpanel">
        <form @keyup.enter="submit" class="form-horizontal auth-form my-4">
            <div class="form-group">
                <label for="firstname">Prénom</label>
                <div class="input-group mb-3">
          <span class="auth-form-icon">
            <i class="icon-sm far fa-user"></i>
          </span>
                    <input
                            :class="{ 'is-invalid': $v.userData.firstName.$error }"
                            class="form-control"
                            id="firstname"
                            name="firstname"
                            placeholder="Entrez votre prénom"
                            type="text"
                            v-model="$v.userData.firstName.$model"
                    />
                    <div class="invalid-feedback" v-if="!$v.userData.firstName.required">
                        {{titles.fieldIsRequired}}
                    </div>
                    <div class="invalid-feedback" v-if="$v.userData.firstName.minLength == false && $v.userData.firstName.$dirty== true
          && $v.userData.firstName.$error == true">
                        {{titles.errorLengthName(3)}}
                    </div>
                </div>
            </div>
            <!--end form-group-->
            <div class="form-group">
                <label for="lastname">Nom</label>
                <div class="input-group mb-3">
          <span class="auth-form-icon">
            <i class="icon-sm far fa-user"></i>
          </span>
                    <input
                            :class="{ 'is-invalid': $v.userData.lastName.$error }"
                            class="form-control"
                            id="lastname"
                            name="lastname"
                            placeholder="Entrez votre nom"
                            type="text"
                            v-model="$v.userData.lastName.$model"
                    />
                    <div class="invalid-feedback" v-if="!$v.userData.lastName.required">
                        {{titles.fieldIsRequired}}
                    </div>
                    <div class="invalid-feedback" v-if="$v.userData.lastName.minLength == false && $v.userData.lastName.$dirty== true
          && $v.userData.lastName.$error == true">
                        {{titles.errorLengthName(3)}}
                    </div>
                </div>
            </div>
            <!--end form-group-->

            <div class="form-group">
                <label for="useremail">Email</label>
                <div class="input-group mb-3">
          <span class="auth-form-icon">
            <i class="icon-sm far fa-envelope"></i>
          </span>
                    <input
                            :class="{ 'is-invalid': $v.userData.email.$error || error == 'UserExist'}"
                            @click="clearError"
                            class="form-control"
                            id="useremail"
                            name="email"
                            placeholder="Entrez votre e-mail"
                            type="email"
                            v-model="$v.userData.email.$model"
                    />
                    <div class="invalid-feedback" v-if="!$v.userData.email.required">
                        {{titles.fieldIsRequired}}
                    </div>
                    <div :class="{ 'invalid-feedback-erreur': error == 'UserExist'}" class="invalid-feedback"
                         v-if="error == 'UserExist'">
                        {{titles.emailExist}}
                    </div>
                    <div class="invalid-feedback" v-if="!$v.userData.email.email">
                        Le champ email doit être valide.
                    </div>
                </div>
            </div>
            <div class="form-group">
                <label for="phone">Phone</label>
                <div class="input-group mb-3 phone-for-signup">
                  <span class="auth-form-icon">
                    <i class="icon-sm fas fa-phone"></i>
                  </span>
                    <VuePhoneNumberInput
                            :border-radius="30"
                            :countries-height="20"
                            :ignored-countries="['IL']"
                            :required="true"
                            :show-code-on-list="true"
                            :translations="translation"
                            @update="phoneClicked"
                            color="#94878B"
                            id="phone"
                            ref="PhoneNumberInput"
                            size="sm"
                            v-model="$v.userData.phone.$model"
                            fetch-country
                    />

                </div>
                <div class="invalid-feedback" v-if="!$v.userData.phone.required">
                    {{titles.fieldIsRequired}}
                </div>
                <div :class="{ 'invalid-feedback-erreur': !phoneIsValid}"
                     class="invalid-feedback">
                    {{titles.invalidPhoneNumber}}
                </div>
                <div class="invalid-feedback" v-if="!$v.userData.email.email">
                    Le champ email doit être valide.
                </div>
            </div>

            <PhoneVerification
                    v-model="$v.userData.code.$model"
                    :is-phone-valid="phoneIsValid"
                    :phone="userData.phone"
                    :phone-number-code="userData.phoneNumberCode"
                    :error="isCodeError"
            />

            <div class="form-group">
                <label for="userpassword">Mot de passe</label>
                <div class="input-group mb-3">
          <span class="auth-form-icon">
            <i class="icon-sm fas fa-key"></i>
          </span>
                    <input
                            :class="{ 'is-invalid': $v.userData.password.$error }"
                            class="form-control"
                            id="userpassword"
                            name="password"
                            placeholder="Entrez votre mot de passe"
                            type="password"
                            v-model="$v.userData.password.$model"
                    />
                    <div class="invalid-feedback" v-if="!$v.userData.password.required">
                        {{titles.fieldIsRequired}}
                    </div>
                    <div
                            class="invalid-feedback"
                            v-if="
              !$v.userData.password.mustBeValidPassword &&
                $v.userData.password.minLength
            "
                    >
                        Le champ du mot de passe doit contenir un nombre, une majuscule et un
                        lettre minuscule.
                    </div>
                    <div class="invalid-feedback" v-if="!$v.userData.password.minLength">
                        Le champ du mot de passe doit contenir au moins 6 caractères.
                    </div>
                </div>
            </div>
            <!--end form-group-->

            <div class="form-group">
                <label for="conf_password">Confirmez le mot de passe</label>
                <div class="input-group mb-3">
          <span class="auth-form-icon">
            <i class="icon-sm fas fa-key"></i>
          </span>
                    <input
                            :class="{ 'is-invalid': $v.userData.retypedPassword.$error }"
                            class="form-control"
                            id="conf_password"
                            name="conf-password"
                            placeholder="Confirmer le mot de passe"
                            type="password"
                            v-model="$v.userData.retypedPassword.$model"
                    />
                    <div
                            class="invalid-feedback"
                            v-if="!$v.userData.retypedPassword.required"
                    >
                        {{titles.fieldIsRequired}}
                    </div>
                    <div
                            class="invalid-feedback"
                            v-if="!$v.userData.retypedPassword.sameAsPassword"
                    >
                        {{titles.passwordNotSame}}
                    </div>
                </div>
                <!--end form-group-->
            </div>
            <!--end form-group-->

            <div class="form-group row mt-4">
                <div class="col-sm-12">
                    <div class="custom-control custom-switch switch-success">
                        <input
                                :class="{ 'is-invalid': $v.userData.agree.$error }"
                                class="custom-control-input"
                                id="termAgree"
                                type="checkbox"
                                v-model="$v.userData.agree.$model"
                        />
                        <label class="custom-control-label text-muted" for="termAgree"
                        >Vous acceptez les
                            <router-link class="text-primary" to="#"
                            >conditions d'utilisation
                            </router-link
                            >
                            de Stark</label
                        >
                        <div class="invalid-feedback" v-if="!$v.userData.agree.mustBeTrue">
                            Vous devez accepter les conditions d'utilisation.
                        </div>
                    </div>
                </div>
                <!--end col-->
            </div>
            <!--end form-group-->

            <div class="form-group mb-0 row">
                <div class="col-12 mt-2">
                    <button
                            :disabled="isLoading || $v.$invalid"
                            class="btn btn-standard-gradient btn-round btn-block waves-effect waves-light"
                            type="button"
                            v-on:click="submit"
                    >
                        <b-spinner small v-if="isLoading"></b-spinner>
                        S'inscrire <i class="fas fa-sign-in-alt ml-1"></i>
                    </button>
                </div>
                <!--end col-->
            </div>
            <!--end form-group-->
        </form>
        <!--end form-->
    </div>
</template>

<script>
    import {
        email,
        helpers,
        minLength,
        maxLength,
        required,
        sameAs
    } from 'vuelidate/lib/validators';
    import {registerUser} from '../../shared/services/user.service';
    import {titles} from '../../../utils/general/titles';
    import VuePhoneNumberInput from 'vue-phone-number-input';
    import PhoneVerification from "./phoneVerification";


    const mustBeValidPassword = helpers.regex(
        'alpha',
        /(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])/
    );
    const mustBeTrue = value => value == true;

    export default {
        name: 'registerTab',
        components: {
            PhoneVerification,
            VuePhoneNumberInput
        },
        data() {
            return {
                titles,
                error: null,
                isCodeError: false,
                isLoading: false,
                userData: {
                    firstName: '',
                    lastName: '',
                    email: '',
                    password: '',
                    retypedPassword: '',
                    state: 1,
                    agree: false,
                    phone: null,
                    phoneNumberCode: null,
                    code: '',
                    countryCode:''

                },
                translation: {
                    countrySelectorLabel: '',
                    countrySelectorError: '',
                    phoneNumberLabel: titles.phone,
                    example: titles.examplePhoneNumber
                },
                phoneIsValid: true,
            };
        },
        validations: {
            userData: {
                email: {
                    required,
                    email
                },
                firstName: {
                    required, minLength: minLength(3)
                },
                lastName: {
                    required, minLength: minLength(3)
                },
                password: {
                    required,
                    mustBeValidPassword,
                    minLength: minLength(6)
                },
                retypedPassword: {
                    required,
                    sameAsPassword: sameAs('password')
                },
                agree: {
                    mustBeTrue
                },
                phone: {
                    required
                },
                phoneNumberCode: {
                    required
                },
                code: {
                    required,
                    minLength: minLength(6),
                    maxLength: maxLength(6)
                }
            }
        },
        methods: {
            submit() {
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }
                this.isLoading = true;
                registerUser(
                    this.userData.firstName,
                    this.userData.lastName,
                    this.userData.email,
                    this.userData.password,
                    this.userData.retypedPassword,
                    this.userData.state,
                    this.userData.phone,
                    this.userData.phoneNumberCode,
                    this.userData.code,
                    parseInt(this.$route.params.idSelectedDomain, 0),
                    parseInt(this.$route.params.idSelectedPack, 0),
                    this.userData.countryCode,

                )
                    .then(() => {
                        this.$emit('goToTab', 1);
                        this.$bvModal.show('email-sent');
                        this.isLoading = false;
                    })
                    .catch(error => {
                        this.error = error.response.data.error;
                        if (this.error.toLowerCase() === "error verification code") {
                            this.isCodeError = true;
                        }
                        this.isLoading = false;
                    });
            },
            clearError() {
                this.error = null;
                this.isCodeError = false;
            },
            phoneClicked(phoneNumberObject) {
                this.userData.countryCode = phoneNumberObject.countryCode ?? null;
                if (!phoneNumberObject.phoneNumber) {
                    this.phoneIsValid = true;
                    this.userData.phoneNumberCode = null;
                } else {
                    this.phoneIsValid = phoneNumberObject.isValid;
                    this.userData.phoneNumberCode = phoneNumberObject.countryCode ?? null;
                }
            },
        }
    };
</script>

<style>
    @import '../../../assets/style/css/vue-phone-number-input-for-signup.css';
    .country-selector.sm .country-selector__input {
        min-height: auto !important;
        border: 0;
    }
</style>
